import { getGuidsToSkip } from '@thoughtspot/session-service';
import { useCallback, useMemo, useState } from 'react';
import { useGetUserGroupPrincipalListQuery } from "../../../../services/user-group/user-group-service";
import { CHECKBOX_SECTION_PAGINATION_BATCHSIZE } from '../../../user-management/util';
import { usePaginatedList } from './use-paginated-list';
export const usePaginatedGroupPrincipalList = (options) => {
    const [searchText, setSearchText] = useState('');
    const [offset, setOffset] = useState(0);
    const skipIds = useMemo(getGuidsToSkip, []);
    const { data, loading } = useGetUserGroupPrincipalListQuery(searchText, skipIds, CHECKBOX_SECTION_PAGINATION_BATCHSIZE, offset, { skip: options?.skip, fetchPolicy: 'cache-and-network' });
    const { items, hasMore, loadMore } = usePaginatedList({
        page: data?.objects,
        isLastBatch: data?.isLastBatch,
        loading,
        resetKey: searchText,
        batchSize: CHECKBOX_SECTION_PAGINATION_BATCHSIZE,
        offset,
        setOffset,
    });
    const handleSearchChange = useCallback((value) => {
        setOffset(0);
        setSearchText(value);
    }, []);
    return {
        items,
        loading,
        searchText,
        setSearchText: handleSearchChange,
        hasMore,
        loadMore,
    };
};
//# sourceMappingURL=use-group-principal-list.js.map